import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: any = {
  locationMarker: undefined,
  driverMarker: undefined,
  driverInfoBox: undefined,
}
const trackingMarkerSlice = createSlice({
  name: 'trackingMarker',
  initialState,
  reducers: {
    trackingUpdateLocationMarker: (state, action: PayloadAction<any>) => {
      if (state.locationMarker) {
        state.locationMarker.setMap(null)
      }
      state.locationMarker = action.payload.marker
    },
    trackingUpdateDriverMarker: (state, action: PayloadAction<any>) => {
      if (state.driverMarker) {
        state.driverMarker.setMap(null)
      }
      state.driverMarker = action.payload.marker
    },
    trackingInitDriverInfoBox: (state, action: PayloadAction<any>) => {
      state.driverInfoBox = action.payload
    },
  },
  extraReducers: () => {},
})
export const trackingMarkerActionsCreator = trackingMarkerSlice.actions

export default trackingMarkerSlice
